class WageAdvanceCardController {
  constructor(EventEmitter) {
    'ngInject';
    this.eventEmitter = EventEmitter;
  }

  cancel() {
    this.onCancel(this.eventEmitter({ advance: this.advance }));
  }
}

export default WageAdvanceCardController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceList/wageAdvanceCard/wageAdvanceCard.controller.js